import { render, staticRenderFns } from "./MaquinaDetail.vue?vue&type=template&id=8d27a9fe&scoped=true"
import script from "./MaquinaDetail.vue?vue&type=script&lang=js"
export * from "./MaquinaDetail.vue?vue&type=script&lang=js"
import style0 from "./MaquinaDetail.vue?vue&type=style&index=0&id=8d27a9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d27a9fe",
  null
  
)

export default component.exports